import { Box } from '@mui/material';
import PageMasthead from './PageMasthead';
import { useAuth } from '../hooks/useAuth';

const PageHeader = ({ title, subtitle, actions, kicker, stat, statLabel, stats, accentColor }) => {
  const { user } = useAuth();

  const autoKicker = (() => {
    if (kicker) return kicker;
    if (!user) return '';
    const roles = user.roles || [];
    let roleName = user.role || '';
    if (roles.length > 0) {
      const minLevel = Math.min(...roles.map(r => r.roleLevel ?? Infinity));
      const bestRole = roles.find(r => r.roleLevel === minLevel);
      if (bestRole) roleName = bestRole.name;
    }
    const companyName = user.company?.name || '';
    return `${roleName}${companyName ? ` · Empresa activa: ${companyName}` : ''}`;
  })();

  return (
    <Box sx={{ mb: 3 }}>
      <PageMasthead
        title={title}
        subtitle={subtitle}
        kicker={autoKicker}
        stat={stat}
        statLabel={statLabel}
        stats={stats}
        accentColor={accentColor}
      />
      {actions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1.5, flexWrap: 'wrap' }}>
          {actions}
        </Box>
      )}
    </Box>
  );
};

export default PageHeader;
